import { mapGetters } from "vuex";

const data = [
    { id: 1, value: "primary", name: "Teacher Primary" },
    { id: 3, value: "consul", name: "Consul" },
    { id: 4, value: "secondary", name: "Teacher Secondary"  },
    { id: 5, value: "international", name: "Teacher International"  },
  ];


export const teacherTypeMixin = {
    computed: {
      ...mapGetters({
        currentUser: "currentUser",
        settings: "settings"
      }),
      teacherTypeSchoolAdmin() {
        return data.find(e => e.value === "admin")
      }
  
    },
    created() {
      this.fetchTypes();
    },
    data() {
      return {
        teacherTypes: [],
  
      };
    },
    methods: {
    fetchTypes() {
        this.teacherTypes = data;
     },
    teacherType(id) {
        return this.teacherTypes.find(function (object) {
            return object.id === id;
          });
    }
  
    }
  }
